import { Link } from 'react-router-dom'

export default function NotFoundPage(): React.JSX.Element {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-serif font-medium mb-4">404</h1>
        <p className="text-muted-foreground mb-6">Page not found</p>
        <Link
          to="/"
          className="inline-flex items-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:opacity-90"
        >
          Go Home
        </Link>
      </div>
    </div>
  )
}
